import React from "react";
import { _t } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

const PrintPaymentModal = ({
  printPaymentModalItem,
  setPrintPaymentModalItem,
  paymentTypeAvailable,
  handlePrint,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        id="printPayment"
        className={`modal fade ${printPaymentModalItem ? "showing" : ""}`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md my-auto mt-3">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="w-100 d-flex align-items-center justify-content-between">
                <div className="rider-text font-weight-bold">{_t(t("Select Payment Type"))}</div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={(e) => {
                    setPrintPaymentModalItem(null);
                  }}
                ></button>
              </div>
            </div>
            <div className="modal-body p-3">
              <div className="bill_modal_scroll" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                <div className="row m-0">
                  {paymentTypeAvailable &&
                    paymentTypeAvailable.map((pay, i) => (
                      <div key={i} className="col-6 mb-2 px-2">
                        <button
                          title={pay.name}
                          className="btn btn-outline-primary w-100 py-2 rounded-sm font-weight-bold shadow-sm text-break"
                          onClick={(e) => {
                            let item = printPaymentModalItem;
                            setPrintPaymentModalItem(null);
                            handlePrint(e, item, pay);
                          }}
                        >
                          <span className="fk-sm-card__title">{pay.name}</span>
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintPaymentModal;
